import { z } from 'zod';

export const zodInvoiceEmailEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.uuid(),
  z.literal('file'),
  z.uuid(),
]);
